//Reference: EN116

import { Mappeable } from './mappeable.model';
import moment from 'moment';
import * as _ from 'lodash';


export class UserAlarm extends Mappeable {


    typeAlarm: any;
    typeCriquiteAlarm: any;
    dateMaturity: string;
    txtFree: string;
    
    constructor(o) {
        super(o);
        this.dateMaturity = moment(this.dateMaturity, "YYYY-MM-DD").format("YYYY-MM-DD");
    }

    public mapToBack() {
        return {
            typeCriquiteAlarm: this.typeCriquiteAlarm,
            dateMaturity: this.dateMaturity,
            txtFree: this.txtFree
        }
    }

}
